import styled from "styled-components";
import { G, HEADER_BG, PC_HEADER_H } from "@/components/gold/theme";

/* ---------- ver2(gold) 헤더 ----------
 *  gold8.bet PC: 화면 위 고정, 높이 97px, 금색 배경, 로고 가운데, 계정 정보 오른쪽.
 *  전역 CSS 의 .header/h1 규칙과 섞이지 않게 className 을 붙이지 않는다.
 *  전역 `* { color }` 규칙이 있어 글자 색은 글자를 담는 요소마다 직접 준다. */
export const GoldHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${PC_HEADER_H}px;
  background: ${HEADER_BG};
  border-bottom: 1px solid ${G.line};
  z-index: 30;
`;

export const GoldHeaderInner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding: 8px 30px;
`;

export const GoldLogo = styled.a`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 285px;
  height: 90px;
`;

export const GoldLogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const GoldAccount = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
`;

export const GoldInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0 20px;
`;

export const GoldInfoItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
`;

/* gold 원본은 아이디를 4글자 폭(max-width:4em)에서 자르지만, 여기서는 아이디 전체를 보여준다 */
export const GoldInfoValue = styled.span`
  margin-left: 4px;
  color: #fff;
  white-space: nowrap;
`;

/** 아이디 옆 말풍선 아이콘(gold m_icon.png 20×20) */
export const GoldAccountIcon = styled.img`
  width: 20px;
  height: 20px;
  margin: 0 10px;
`;

export const GoldSync = styled.button`
  display: flex;
  width: 16px;
  height: 16px;
  margin-left: 20px;
  padding: 0;
  border: 0;
  background: none;
  color: #fff;
  cursor: pointer;
  svg { width: 100%; height: 100%; fill: currentColor; color: inherit; }
  &:hover { color: ${G.goldText}; }
`;

export const GoldSignout = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 45px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 12px;
  color: ${G.muted};
  white-space: nowrap;
  cursor: pointer;
  svg { width: 12px; height: 12px; fill: currentColor; color: inherit; }
  &:hover { opacity: 0.8; }
`;

export const GoldLoginBtn = styled.button`
  width: 100px;
  height: 40px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  &:hover { opacity: 0.8; }
`;

/* ---------- 언어 선택 ---------- */
export const GrandLoginLang = styled.div.attrs({
  className: "login-lang",
})``;

export const GrandLangSelectorRoot = styled.div.attrs((p) => ({
  id: "languageSelector",
  className: p.$isActive ? "lang-selector active" : "lang-selector",
}))``;

export const GrandLangBtn = styled.button.attrs({
  type: "button",
  className: "lang-btn",
  "aria-haspopup": "listbox",
})``;

export const GrandLangImgWrap = styled.span.attrs({
  className: "lang-img",
})``;

export const GrandLangText = styled.span.attrs({
  className: "lang-text",
})``;

export const GrandLangChevronSvg = styled.svg.attrs({
  viewBox: "0 0 24 24",
  className: "lang-btn__chevron",
})`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  fill: none !important;
  stroke: currentColor !important;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  color: inherit;

  /* GlobalStyle * { color: var(--c-gray-200) } 가 polyline 에 직접 들어가 currentColor 스트로크가 회색이 됨 */
  polyline {
    color: #ffffff;
  }
`;

export const GrandLangList = styled.ul.attrs({
  className: "lang-list",
  role: "listbox",
})``;

export const GrandLangListItem = styled.li.attrs((p) => ({
  role: "option",
  "data-lang": p.$dataLang,
  className: p.$selected ? "lang-item selected" : "lang-item",
  ...{ "lang-selected": p.$selected ? "true" : "false" },
}))``;

export const GrandLangItemFlagWrap = styled.span``;

export const GrandLangOptionBtn = styled.button.attrs({ type: "button" })``;

export const GrandLangFlagImg = styled.img``;
